/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface DeleteFleetsFleetIdWingsWingIdNotFound
 */
export interface DeleteFleetsFleetIdWingsWingIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof DeleteFleetsFleetIdWingsWingIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the DeleteFleetsFleetIdWingsWingIdNotFound interface.
 */
export function instanceOfDeleteFleetsFleetIdWingsWingIdNotFound(value: object): value is DeleteFleetsFleetIdWingsWingIdNotFound {
    return true;
}

export function DeleteFleetsFleetIdWingsWingIdNotFoundFromJSON(json: any): DeleteFleetsFleetIdWingsWingIdNotFound {
    return DeleteFleetsFleetIdWingsWingIdNotFoundFromJSONTyped(json, false);
}

export function DeleteFleetsFleetIdWingsWingIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFleetsFleetIdWingsWingIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function DeleteFleetsFleetIdWingsWingIdNotFoundToJSON(json: any): DeleteFleetsFleetIdWingsWingIdNotFound {
    return DeleteFleetsFleetIdWingsWingIdNotFoundToJSONTyped(json, false);
}

export function DeleteFleetsFleetIdWingsWingIdNotFoundToJSONTyped(value?: DeleteFleetsFleetIdWingsWingIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

